// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h2HdmtE3gEkX3QqZUDwF,.LjV8aQhRbwMZ7VDpUb7U{width:109px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpGuideButton": `h2HdmtE3gEkX3QqZUDwF`,
	"newLinkButton": `LjV8aQhRbwMZ7VDpUb7U`
};
export default ___CSS_LOADER_EXPORT___;
